import React, { useEffect } from "react";

import "../styles/birthday.css";
import logo from "../assets/img/birthday/logo.png";
import sim1 from "../assets/img/birthday/sim1.png";
import sim2 from "../assets/img/birthday/sim2.png";
import local from "../assets/img/birthday/local.png";
import data from "../assets/img/birthday/data.png";
import dresscode from "../assets/img/birthday/dresscode.png";
import bannerdesk from "../assets/img/birthday/banner-desk.png";
import bannermob from "../assets/img/birthday/banner-mob.png";
import footerdesk from "../assets/img/birthday/footer-desk.png";
import footermob from "../assets/img/birthday/footer-mob.png";
import sim2_3 from "../assets/img/birthday/sim2-3.png";
import sim2_4 from "../assets/img/birthday/sim2-4.png";
import sim4 from "../assets/img/birthday/sim4.png";

function Birthday() {
  return (
    <div className="birthday">
      <div className="navbar">
        <img src={logo} alt="Logo" className="logo" />
        <ul>
          <li>
            <a href="#sobre">Sobre</a>
          </li>
          <li>
            <a href="#infos">Informações</a>
          </li>
          <li>
            <a href="#rsvp">Confirmar Presença</a>
          </li>
        </ul>
      </div>
      <div className="hero">
        <a
          href="https://www.instagram.com/emy.chrystinne/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={bannerdesk} className="desk" />
          <img src={bannermob} className="mob" />
        </a>
      </div>
      <div className="content">
        <div className="sobre" id="sobre">
          <div className="post-it">
            <p className="separador">memo</p>
            <p className="text">
              Ainda não comprei minha casa própria, nem virei adulta de
              verdade... mas cheguei até aqui cheia de histórias, bugs e{" "}
              <span>pessoas incríveis</span> ao meu lado.
            </p>
            <p className="text">
              No dia 16 de Maio, faço 25 e quero comemorar isso com <span>você</span>!
            </p>
            <p className="text">
              No sábado 17, vai ter comidinhas, joguinhos, muita risada e zero pressão.
            </p>
            <p className="text">
              <span>Sua presença vai deixar tudo ainda mais especial 💛</span>
            </p>
          </div>
          <div className="sim">
            <img src={sim1} alt="Sim" className="desk" />
            <img src={sim2_3} alt="Sim" className="mob" />
          </div>
        </div>
      </div>
      <div className="infos" id="infos">
        <div className="infos-list">
          <div className="infos-item">
            <img src={data} alt="Data" className="infos-icon" />
            <h2>Data e Horário</h2>
            <p className="infos-text">17/05/2025 - Sábado</p>
            <p className="infos-text">A partir das 16h</p>
          </div>
          <div className="infos-item">
            <img src={local} alt="Local" className="infos-icon" />
            <h2>Local</h2>
            <p className="infos-text">Minha casa</p>
            <p className="infos-text"></p>
          </div>
          <div className="infos-item">
            <img src={dresscode} alt="Dresscode" className="infos-icon" />
            <h2>DressCode</h2>
            <p className="infos-text">
              Se quiser brincar com o tema anos 2000, pensa em vibes Sandy &
              Júnior, RBD, Britney, Calypso... ou aquele look que você usava na
              escola com orgulho em 2005.
            </p>
            <p className="infos-text">
              Mas se der preguiça de pensar em roupa, tudo bem também. O
              importante é você vir!
            </p>
          </div>
        </div>
      </div>
      <div className="content">
        <div className="rsvp" id="rsvp">
          <div className="sim">
            <img src={sim2} alt="Sim" className="desk" />
            <img src={sim2_4} alt="Sim" className="mob" />
          </div>
          <div className="conteudo">
            <div className="post-it">
              <p className="separador">memo</p>
              <p className="text">
                Vai ser um rolê leve, mas feito com carinho (e muito brigadeiro,
                claro!).
              </p>
              <p className="text">
                <span>
                  Me ajuda a organizar as coisas e confirma se vai dar as caras!
                  😉
                </span>
                !
              </p>
              <p className="text">
                Ah, e já salva aí no calendário pra não esquecer (tipo aquele
                rolê que a gente sempre fica de combinar e não combina nunca).️
              </p>
              <div className="rsvp-button">
                <a
                  href=" https://wa.me/5582988073209?text=Confirmo%20minha%20presen%C3%A7a%20na%20sua%20festa.%20J%C3%A1%20t%C3%B4%20no%20clima%20de%20salgadinho%20e%20brigadeiro!"
                  target="_blank"
                  id="rsvp-button-tipe"
                >
                  Confirmar Presença
                </a>
              </div>
            </div>
            <div className="botoes">
              <a
                href="https://calendar.app.google/wapDg7RqxX56EEWKA"
                id="calendar"
              >
                Salvar no Google Agenda
              </a>
              <a href="/docs/Convite.png" download id="convite">
                Baixar Convite
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="content1">
        <div className="rsvp" id="presentes">
          <div className="sim">
            <img src={sim4} alt="Sim" className="desk" />
            <img src={sim4} alt="Sim" className="mob" />
          </div>
          <div className="conteudo">
            <div className="post-it">
              <p className="separador">memo</p>
              <p className="text">
                <span>
                Presente? Só se der vontade (ou um bug no carrinho da Amazon)
                </span>
              </p>
              <p className="text">
              Atenção: não é obrigatório me dar nada. <span>Presente é só um bônus. O principal mesmo é a sua presença!</span>.️
              </p>
              <p className="text">
              Mas vai que o algoritmo do seu coração decide te empurrar pra um mimozinho, né?
              </p>
              <p className="text">
              Separei duas listas para facilitar sua vida:
              </p>
            </div>
            <div className="botoes">
              <a
                href="https://www.amazon.com.br/hz/wishlist/ls/1KIN1ZU5VL7NO?ref_=wl_share"
                id="lista1"
              >
                Presentes
              </a>
              <a href="https://www.amazon.com.br/hz/wishlist/ls/3HB8QD48ZJUU3?ref_=wl_share" id="lista2">
                Jogos
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="footer">
        <div className="footer-img">
          <img src={footerdesk} className="desk" />
          <img src={footermob} className="mob" />
        </div>
        <div className="footer-texto">
          <p className="footer-text">Feito com carinho por Emy | 2025</p>
        </div>
      </div>
    </div>
  );
}

export default Birthday;
